/* ============ ROOM 33 — "THE OFFERING" — Video sound-on-scroll + manual toggle ============ */
(function () {
  var userHasInteracted = false;
  function markInteracted() {
    userHasInteracted = true;
    ['pointerdown', 'keydown', 'touchstart', 'wheel'].forEach(function (evt) {
      document.removeEventListener(evt, markInteracted);
    });
  }
  ['pointerdown', 'keydown', 'touchstart', 'wheel'].forEach(function (evt) {
    document.addEventListener(evt, markInteracted, { passive: true, once: true });
  });

  function initOffering(root) {
    if (root._offeringReady) return;
    root._offeringReady = true;

    var wrap = root.querySelector('[data-offering-video-wrap]');
    var video = wrap ? wrap.querySelector('video') : null;
    var toggle = root.querySelector('[data-sound-toggle]');
    if (!video) return;

    var label = toggle ? toggle.querySelector('[data-sound-label]') : null;
    var manuallyMuted = false; // becomes true only if the visitor explicitly clicks to mute

    function setUI(soundOn) {
      if (toggle) toggle.setAttribute('aria-pressed', soundOn ? 'true' : 'false');
      if (label) label.textContent = soundOn ? 'Sound Off' : 'Sound On';
    }

    function tryUnmute() {
      if (manuallyMuted) return; // respect the visitor's own choice, don't override it
      video.muted = false;
      var playAttempt = video.play();
      if (playAttempt && typeof playAttempt.then === 'function') {
        playAttempt.then(function () {
          setUI(!video.muted);
        }).catch(function () {
          // browser blocked sound (no interaction yet) — keep it playing muted, no error shown
          video.muted = true;
          video.play().catch(function () {});
          setUI(false);
        });
      } else {
        setUI(!video.muted);
      }
    }

    // Auto-unmute the moment the video scrolls into view (only once the visitor
    // has interacted with the page at least once — required by every browser's
    // autoplay-with-sound policy; until then it plays muted as a safe fallback).
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            if (userHasInteracted) {
              tryUnmute();
            } else {
              // wait for the first interaction, then unmute as soon as it happens
              var onFirstInteract = function () {
                tryUnmute();
                document.removeEventListener('pointerdown', onFirstInteract);
                document.removeEventListener('keydown', onFirstInteract);
                document.removeEventListener('touchstart', onFirstInteract);
              };
              document.addEventListener('pointerdown', onFirstInteract, { once: true });
              document.addEventListener('keydown', onFirstInteract, { once: true });
              document.addEventListener('touchstart', onFirstInteract, { once: true });
            }
          } else {
            // leaving the section — mute again so it doesn't keep playing sound off-screen
            if (!video.muted) {
              video.muted = true;
              setUI(false);
            }
          }
        });
      }, { threshold: 0.5 });
      io.observe(wrap || video);
    }

    // Manual toggle still works exactly as before, and overrides the auto-behavior
    if (toggle) {
      toggle.addEventListener('click', function () {
        video.muted = !video.muted;
        manuallyMuted = video.muted;
        var soundOn = !video.muted;
        setUI(soundOn);
        if (soundOn && video.paused) {
          video.play().catch(function () {});
        }
      });
    }
  }

  function scan(root) {
    (root || document).querySelectorAll('.room33-offering').forEach(initOffering);
  }

  if (document.readyState !== 'loading') scan();
  else document.addEventListener('DOMContentLoaded', function () { scan(); });
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
})();